<template>
  <list-view-layout>
    <div v-for="resource in resources" :key="resource.id" class="flex flex-col my-4">
      <list-view-item-layout :resource="resource" />
    </div>
  </list-view-layout>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ListViewLayout from '@/layouts/ListViewLayout'
import ListViewItemLayout from '@/layouts/ListViewItemLayout'

export default {
  name: 'Resources',
  components: { ListViewLayout, ListViewItemLayout },
  setup() {
    const store = useStore()
    const route = useRoute()

    const resources = computed(() => {
      const response = store.getters[route.name + '/currentResponse']
      return response?.items
    })

    return {
      resources,
    }
  },
}
</script>

<style scoped>

</style>
